import { render, staticRenderFns } from "./ModelInput.vue?vue&type=template&id=3878f937&scoped=true&"
import script from "./ModelInput.vue?vue&type=script&lang=js&"
export * from "./ModelInput.vue?vue&type=script&lang=js&"
import style0 from "./ModelInput.vue?vue&type=style&index=0&id=3878f937&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3878f937",
  null
  
)

export default component.exports